import { createFileRoute, redirect } from "@tanstack/react-router";
import { ContractsPage } from "@/app/partner/pages/contracts";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/contracts/")({
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "contracts");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: ContractsRoute,
});

function ContractsRoute() {
	return <ContractsPage />;
}
